/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import store from "../../store";
import EmployerStatisticsMetrics from "./EmployerStatisticsMetrics";

const ProviderComponent = () => (
  <Provider store={store}>
    <EmployerStatisticsMetrics />
  </Provider>
);

export default ProviderComponent;
